import store from '../../../store'

const getActiveMouse = () => {
  return store.getters.GET_ACTIVE_MOUSE
}

const getActiveSuggestTmp = () => {
  return store.getters.GET_ACTIVE_SUGGEST_TMP
}

const getIsActiveSuggestions = () => {
  return store.getters.GET_IS_ACTIVE_SUGGESTIONS
}

const getIsActiveAutocompleteDropdown = () => {
  return store.getters.GET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN
}

export {
  getActiveMouse,
  getActiveSuggestTmp,
  getIsActiveSuggestions,
  getIsActiveAutocompleteDropdown
}



// WEBPACK FOOTER //
// ./src/scripts/modules/store/autocompleteStore-getters.js